// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// Utils
import { getEMRErrorMessage } from "src/utils/emr/emrErrorHelper";

// API
import { deleteEMRHub } from "../../api";

export const useDeleteEMRHub = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (hubId: string) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return deleteEMRHub(token, clinicId, hubId);
      } catch (error) {
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emr-hubs", clinicId] });
      setSnackbarInfo({
        variant: "success",
        message: t("EMR hub deleted successfully!"),
      });
    },
    onError: (error) => {
      setSnackbarInfo({
        variant: "error",
        message: getEMRErrorMessage(
          error,
          t("EMR hub could not be deleted!"),
          t
        ),
      });
    },
  });
};
